export default "/images/8267fa1cf5e653137cff2670d001c469.avif";